<template>
  <div class="">
    <sticky class="page-header sticky-page-header page-header--new"
            :bigTotal="bigTotal"
            :back-button="true"
            :loading="loading" :total="bigTotal"
            :label="'Option'">
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser données</span>
      </a>
      <a @click="exportXls('options-export', query, true)" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-file-export"></i></span>
        <span>Exporter options</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart"
          id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div v-if="isAdmin || isSectorManager" class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @select="updateCompanyFilter" @remove="updateCompanyFilter(null)"
                            class="multiselect--option-ico is-single_choice"
                            v-model="filters.company" track-by="pk"
                            :options="companies" :searchable="true"
                            :custom-label="companyName" :show-labels="false" :placeholder="''"
                            @search-change="getCompanies">
                  <span slot="placeholder" class="multiselect__placeholder">Société</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-xsmall is-paddingless-bottom">
              <div class="control">
                <multiselect @select="updateProgramFilter" @remove="changeFilters"
                             v-model="filters.program" label="name"
                             track-by="pk"
                             class="multiselect--option-ico"
                             :options="programs" :searchable="true"  :show-labels="false"
                             @search-change="getPrograms">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="programs.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Programme</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-xsmall is-paddingless-bottom">
              <div class="control">
                <multiselect @select="updateLotFilter" @remove="changeFilters" v-model="filters.lot" label="ref"
                             track-by="pk" :custom-label="lotName"
                             class="multiselect--option-ico"
                             :options="lots" :searchable="true"  :show-labels="false"
                             @search-change="getLots">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="lots.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun lot trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Lot</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-padding-top-xsmall is-paddingless-bottom" v-if="isAdmin || isSectorManager || isManager">
              <div class="control">
                <multiselect v-model="filters.seller" @select="updateSellerFilter" @remove="changeFilters"
                             label="seller" :placeholder="''"
                             class="multiselect--option-ico"
                             track-by="pk"
                             :custom-label="sellerName"
                             :options="users" :searchable="true"  :show-labels="false"
                             @search-change="getUsers">
                  <span slot="placeholder" class="multiselect__placeholder">Vendeur</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="isDistributeurMode && !isExternal">
            <div class="column is-padding-top-xsmall is-paddingless-bottom">
              <div class="control">
                <multiselect @select="updatePromoteurFilter" @remove="changeFilters" v-model="filters.promoteur" label="name"
                             track-by="pk"
                             class="multiselect--option-ico"
                             :options="promoteurs" :searchable="true"  :show-labels="false"
                             @search-change="getPromoteurs">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="promoteurs.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Promoteur</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns is-padding-left is-padding-right">
            <div class="column is-paddingless-left is-paddingless-right is-padding-top-xsmall">
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-padding-left-small is-padding-right-small is-min-width-0">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr :config="configDate" v-model="optionPeriod"
                              class="input" name="date"
                              :class="['is-padding-left-xxsmall is-paddingless-right']"
                              placeholder="Date de création"
                              @on-change="updateOptionCreatedPeriodFilter">
                  </flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-grey is-inverted is-border is-padding-left-small is-padding-right-small is-min-width-0" @click="optionPeriod = null">
                    <span class="icon"><i class="fas fa-times"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} option(s)</div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-narrow">
              <button class="page-header-btn is-square is-static is-ghost">
                <span class="icon"><i class="fas fa-sort-amount-upXX"></i></span>
              </button>
            </div>
          </div>
          <div class="is-padding-top is-padding-right is-padding-left" v-if="hasFilter">
            <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
            <div class="tags">
              <span class="tag is-primary is-rounded" v-if="filters.program">
                {{filters.program.name}} <a @click="updateProgramFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.lot">
                {{filters.lot.ref}} <a @click="updateLotFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.seller">
                {{sellerName(filters.seller)}} <a @click="updateSellerFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.promoteur">
                {{filters.promoteur.name}} <a @click="updatePromoteurFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="optionPeriod">
                {{optionPeriod}} <a @click="optionPeriod = null" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
                Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
              </span>
            </div>
          </div>
          <div class="column is-narrow">
            <label class="checkbox checkRadioIsHide is-padding-right-xsmall" :for="s.value" v-for="s in availableOptionStatusList" :key="s.value">
                <input type="checkbox" :id="s.value" v-model="filters.status" @click="changeStatusFilter(s.value)" :value="s.value">
                <span class="tag" :class="statusColor(s.value)">
                    <span v-if="s.value === 'canceled_by_admin'">Terminé</span>
                    <span v-else>{{s.label}}</span>
                    <span class="icon"><i class="far" :class="filters.status.includes(s.value) ? 'fa-check-square' : 'fa-square'"></i></span>
                </span>
            </label>
          </div>
          <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                          :sticky-datas="stickyDatas" :reload-controls="loading && items.length">
            <table v-show="!loading && items.length"
              class="table is-fullwidth is-first-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
              <thead>
              <tr class="is-size-6">
                <th class="is-paddingless has-text-centered actions" style="z-index:2;">
                  <div class="dropdown is-hoverable is-left">
                    <div class="dropdown-trigger">
                      <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                        <i class="fal fa-cog"></i>
                      </button>
                    </div>
                    <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
                  </div>
                </th>
                <!--<th>
                  <sortable @sort="sort('status', $event)" :sort="sortBy.status" label="Statut"></sortable>
                </th>-->
                <th>
                  <sortable @sort="sort('lot_ref', $event)" :sort="sortBy.lot_ref" label="Lot"></sortable>
                </th>
                <th v-if="showColumn('program_name')">
                  <sortable @sort="sort('program_name', $event)" :sort="sortBy.program_name"
                            label="Programme"></sortable>
                </th>
                <th v-if="isDistributeurMode && !isExternal && showColumn('promoteur_name')">
                  <sortable @sort="sort('promoteur_name', $event)" :sort="sortBy.promoteur_name"
                            label="Promoteur"></sortable>
                </th>
                <th v-if="(isAdmin || isSectorManager) && showColumn('company_name')">
                  <sortable @sort="sort('company_name', $event)" :sort="sortBy.company_name" label="Société"></sortable>
                </th>
                <th v-if="(isAdmin || isManager || isSectorManager) && showColumn('seller_name')">
                  <sortable @sort="sort('seller_name', $event)" :sort="sortBy.seller_name" label="Vendeur"></sortable>
                </th>
                <th v-if="showColumn('buyer_name')">
                  <sortable @sort="sort('buyer_name', $event)" :sort="sortBy.buyer_name" label="Contact"></sortable>
                </th>
                <th v-if="showColumn('created_on')">
                  <sortable @sort="sort('created_on', $event)" :sort="sortBy.created_on"
                            label="Date de création"></sortable>
                </th>
                <th v-if="showColumn('start_date')">
                  <sortable @sort="sort('start_date', $event)" :sort="sortBy.start_date"
                            label="Date de début"></sortable>
                </th>
                <th v-if="showColumn('end_date')">
                  <sortable @sort="sort('end_date', $event)" :sort="sortBy.end_date" label="Date de fin"></sortable>
                </th>
                <th class="has-text-centered"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(option, index) in items" :key="option.pk" :class="{'is-warning': option.pk === lastOption}"
                  class="is-size-6">
                <td class="has-text-centered">
                  <!-- <span class="tag" :class="statusColor(option.status)">{{optionStatus[option.status].label}}</span> -->
                  <span class="dot tooltip" :class="option.status|dotClass"
                        :data-tooltip="optionStatus[option.status].label"></span>
                </td>
                <td class="is-cell-hoverable">
                  <router-link :to="{name: 'LotVue', params: {id: option.lot.pk || option.lot}}" class="fullLink">
                    {{option.lot_ref}}
                  </router-link>
                </td>
                <td v-if="showColumn('program_name')" class="is-cell-hoverable">
                  <router-link :to="{name: 'ProgramVue', params: {id: option.program}}" class="fullLink"
                               v-if="option.program">
                    {{option.program_name}}
                  </router-link>
                  <span v-else>{{option.program_name}}</span>
                </td>
                <td v-if="isDistributeurMode && !isExternal && showColumn('promoteur_name')">
                  <span v-if="option.promoteur_name">
                    {{ option.promoteur_name }}
                  </span>
                  <span v-else>--</span>
                </td>
                <td v-if="(isAdmin || isSectorManager) && showColumn('company_name')">
                  <router-link v-if="option.company" :to="{name: 'CompanyVue', params: {id: option.company}}">
                    {{option.company_name}}
                  </router-link>
                  <span v-else>--</span>
                </td>
                <td v-if="(isAdmin || isSectorManager || isManager) && showColumn('seller_name')" class="is-cell-hoverable">
                  <router-link :to="{name: 'UserVue', params: {id: option.seller}}">
                    {{option.seller_name}}
                  </router-link>
                </td>
                <td v-if="showColumn('buyer_name')" class="is-cell-hoverable">
                  <router-link :to="{name: 'ContactVue', params: {id: option.buyer}}">
                    {{option.buyer_name}}
                  </router-link>
                </td>
                <td v-if="showColumn('created_on')">
                  <span>
                    {{ option.created_on | prettyDatetime }}
                  </span>
                </td>
                <td v-if="showColumn('start_date')">
                  <span v-if="option.status === 'waiting_list' || option.status === 'approved'">
                    {{ option.start_date | prettyDatetime }}
                  </span>
                  <span v-else>--</span>
                </td>
                <td v-if="showColumn('end_date')">
                  <span v-if="option.status === 'waiting_list' || option.status === 'approved'">
                    {{ option.end_date | prettyDatetime }}
                  </span>
                  <span v-else>--</span>
                </td>
                <td class="has-text-centered">
                  <display-button-list
                    :forceDropDown="true" :buttons="buttonList" :data="option"
                    :openUp="{'position': index, 'total': items.length}">
                  </display-button-list>
                </td>
              </tr>
              <tr class="empty empty--row" v-for="n in items.length < 3 ? 3 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </tbody>
            </table>
          </table-h-scroll>
          <div class="is-border-top" v-if="totalPage > 1 && nextPage">
            <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
              <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
              <span class="is-size-6">Afficher la suite</span>
            </a>
            <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
          </div>
          <div v-show="!loading && !items.length">
            <div class="columns">
              <div class="column">
                <h2 class="title is-3 has-text-weight-bold">Aucune option disponible</h2>
                <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                  class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort, Filter, DefaultValues, OptionStatus, ColumnConf, TableHeaderSticky } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import { isNil, debounce } from 'lodash'
  import moment from 'moment'
  import { exportXls } from '../../utils'

  export default {
    name: 'OptionList',
    mixins: [GenericList, Sort, Filter, DefaultValues, OptionStatus, ColumnConf, TableHeaderSticky],
    data () {
      return {
        deleteText: 'Êtes vous sûr de vouloir annuler cette option ? ',
        columnsConfResource: 'options',
        opened: true,
        buttonList: [
          {
            action: (id, option) => {
              this.$store.commit('setQuickview', {mode: 'OPTION_UPDATE_DATE', params: {source: option}})
            },
            icon: 'fa-clock',
            text: 'Modifier date de fin',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              this.$router.push({name: 'ResaCreate', params: {id}})
            },
            icon: 'fa-handshake',
            text: 'Passer en réservation',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              this.loading = true
              this.$api.optionService.patch(id, {status: 'approved'}).then(r => {
                this.loading = false
                this.updateOption(id, r.data, {
                  text: 'L\'option a été acceptée.', type: 'is-success'
                })
              })
            },
            icon: 'fa-check',
            text: 'Accepter',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canApprove(o.status)
            }
          },
          {
            action: (id) => {
              this.loading = true
              this.confirmDelete().then(r => {
                this.loading = false
                if (r.value) {
                  this.$api.optionService.patch(id, {status: 'refused'}).then(r => {
                    this.updateOption(id, r.data, {text: 'L\'option a été refusée.', type: 'is-success'})
                  })
                }
              })
            },
            icon: 'fa-times-octagon',
            needProfile: ['admin', 'sector_manager'],
            text: 'Refuser',
            display: (o) => {
              return this.canRefuse(o.status)
            }
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fa-trash',
            text: 'Annuler',
            display: (o) => {
              return this.canCancel(o.status) && (this.isAdmin || this.isSectorManager || o.seller === this.userId)
            }
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fa-trash',
            needProfile: ['admin'],
            text: 'Annuler',
            display: (o) => {
              return false
            }
          }
        ],
        companies: [],
        programs: [],
        promoteurs: [],
        lots: [],
        exportXls,
        loadDocuments: this.loadItems,
        service: this.$api.optionService,
        users: [],
        filters: {
          status: ['approved', 'waiting_list', 'pending']
        },
        initFilters: {
          status: []
        },
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        optionPeriod: null,
        infiniteLoaderEnabled: true
      }
    },
    watch: {
      'filters.program' (v) {
        this.getLots(null, v)
      },
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'OPTION_UPDATE_DATE') {
            this.changeOptionEndDate(results)
          }
        }
      }
    },
    computed: {
      ...mapState({
        lastOption: 'lastOption',
        userId: 'userId',
        quickview: 'quickview',
        promoteursList: 'promoteurs'
      }),
      ...mapGetters(['isAdmin', 'isManager', 'isSectorManager', 'isExternal', 'isDistributeurMode']),
      availableOptionStatusList () {
        const okStatus = ['pending', 'approved', 'waiting_list', 'refused', 'canceled_by_admin']
        return this.optionStatusList.filter(x => {
          return okStatus.includes(x.value)
        })
      },
      columnsShow () {
        const columns = {
          'program_name': {label: 'Programme', mobile: true}
        }
        if (!this.isExternal && this.isDistributeurMode) {
          columns.promoteur_name = {label: 'Promoteur', mobile: true}
        }
        if (this.isAdmin || this.isSectorManager) {
          columns.company_name = {label: 'Société', mobile: true}
        }
        if (this.isAdmin || this.isSectorManager || this.isManager) {
          columns.seller_name = {label: 'Vendeur', mobile: true}
        }
        columns.buyer_name = {label: 'Contact', mobile: true}
        columns.created_on = {label: 'Date de création', mobile: true}
        columns.start_date = {label: 'Date de début', mobile: true}
        columns.end_date = {label: 'Date de fin', mobile: true}
        return columns
      }
    },
    methods: {
      companyName (value) {
        return value.name
      },
      lotName (value) {
        return `${value.ref} (${value.program_name})`
      },
      changeStatusFilter (value) {
        if (value === 'canceled_by_admin') {
          if (!this.filters.status.includes('canceled_by_admin')) {
            this.filters.status.push('canceled_by_admin', 'canceled_by_seller', 'expired')
          } else {
            let indexCancelAdmin = this.filters.status.findIndex(x => x === 'canceled_by_admin')
            if (indexCancelAdmin >= 0) this.filters.status.splice(indexCancelAdmin, 1)
            let indexCancelSeller = this.filters.status.findIndex(x => x === 'canceled_by_seller')
            if (indexCancelSeller >= 0) this.filters.status.splice(indexCancelSeller, 1)
            let indexExpired = this.filters.status.findIndex(x => x === 'expired')
            if (indexExpired >= 0) this.filters.status.splice(indexExpired, 1)
          }
        }
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      changeOptionEndDate (data) {
        this.$api.optionService.patch(data.option.pk, {end_date: data.date}).then(r => {
          this.updateOption(data.option.pk, r.data, {})
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Impossible de mettre à jour la date de fin de l\'option.'
          })
        })
      },
      updateCompanyFilter (e) {
        this.$set(this.filters, 'company', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateLotFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'lot', e)
        else this.$set(this.filters, 'lot', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateProgramFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'program', e)
        else this.$set(this.filters, 'program', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updatePromoteurFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'promoteur', e)
        else this.$set(this.filters, 'promoteur', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateSellerFilter (e) {
        if (!isNil(e)) this.$set(this.filters, 'seller', e)
        else this.$set(this.filters, 'seller', undefined)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      beforeGet () {
        if (typeof this.query.lot === 'object') {
          this.query.lot = this.query.lot.pk
        }
        if (typeof this.query.program === 'object') {
          this.query.program = this.query.program.pk
        }
        if (typeof this.query.promoteur === 'object') {
          this.query.promoteur = this.query.promoteur.pk
        }
        if (!isNil(this.query.seller) && typeof this.query.seller === 'object') {
          this.query.seller = this.query.seller.pk
        }
        if (!this.query.status || !this.query.status.length) {
          this.query.status = this.availableOptionStatusList.map(x => x.value)
        }
      },
      beforeResetFilters () {
        this.optionPeriod = null
      },
      getLots: debounce(function (query, program) {
        let params = {}
        if (query) params.ref = query
        if (program && program.pk) params.program = program.pk
        this.$api.lotService.get(params).then(r => {
          this.lots = r.data.items
        })
      }, 300),
      getPrograms: debounce(function (query) {
        this.$api.programService.get({name: query}).then(r => {
          this.programs = r.data.items
        })
      }, 300),
      getCompanies: debounce(function (query) {
        this.$api.companyService.get({name: query}).then(r => {
          this.companies = r.data.items
        })
      }, 300),
      getPromoteurs: debounce(function (query) {
        this.$api.promoteurService.get({name: query}).then(r => {
          this.promoteurs = r.data.items
        })
      }, 300),
      getUsers (query) {
        let filters = {}
        if (query) {
          filters.first_name = query
        }
        this.$api.userService.get(filters).then(r => {
          this.users = r.data.items
        })
      },
      updateOption (id, option, {text, type}) {
        if (!text) {
          text = 'L\'option a été mise à jour.'
        }
        if (!type) {
          type = 'is-success'
        }
        const i = this.items.findIndex((o) => {
          return id === o.pk
        })
        if (i >= 0) {
          this.items.splice(i, 1, option)
          this.$notify({
            type,
            text
          })
        }
      },
      sellerName ({first_name, last_name}) {
        // eslint-disable-next-line camelcase
        if (first_name && last_name) {
          const names = {firstName: first_name, lastName: last_name}
          return `${names.firstName} ${names.lastName}`
        }
        return 'Selectionner un vendeur'
      },
      successDelete (id, option) {
        this.loading = false
        this.updateOption(id, option, {text: 'L\'option a été annulée.', type: 'is-success'})
      },
      confirmDelete () {
        return this.$swal({
          title: 'Annulation',
          text: 'Êtes vous sûr de vouloir annuler cette option ?'
        })
      },
      tagColors (v) {
        const COLORS = {
          reserved: 'is-reserve',
          sold: 'is-acte',
          canceled_by_admin: 'is-draft'
        }
        return COLORS[v]
      },
      updateOptionCreatedPeriodFilter: debounce(function (e) {
        if (e.length === 2 && (e[0] !== this.filters.created_on__gte || e[1] !== this.filters.created_on__lte)) {
          this.$set(this.filters, 'created_on__gte', moment(e[0]).format('DD/MM/YYYY'))
          this.$set(this.filters, 'created_on__lte', moment(e[1]).format('DD/MM/YYYY'))
          this.$nextTick(() => {
            this.changeFilters()
          })
        } else if (e.length === 0) {
          this.$set(this.filters, 'created_on__gte', undefined)
          this.$set(this.filters, 'created_on__lte', undefined)
          this.$nextTick(() => {
            this.changeFilters()
          })
        }
      }, 500)
    },
    created () {
      if (this.$route.query.pk) {
        this.filters.pk = [this.$route.query.pk]
      }
      if (this.$route.query.lot) {
        this.filters.lot = this.$route.query.lot
      }
      if (this.$route.query.status) {
        this.filters.status = this.$route.query.status
      }
      this.sort('start_date', {
        order: 'desc',
        sort: true
      })
      this.getCompanies()
      this.getPrograms()
      this.getLots()
      this.getUsers()
      if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
      }
    }
  }
</script>

<style>
  is-annonce {
    background-color: #f87051
  }
</style>



// WEBPACK FOOTER //
// src/components/option/OptionList.vue